import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Home } from "lucide-react"; // ✅ Import icon
import "./BlogsPage.css";
import { motion } from "framer-motion";
const GOOGLE_SHEET_API_URL =
  "https://script.google.com/macros/s/AKfycbzNePVdb8kwFqV381MKbgR7I5GZKH5Gg9nF_ypfCgizYYMouNsMpWa8eku_MuVcqWIJgA/exec";
export default function BlogsPage() {
  const [blogs, setBlogs] = useState([]);
  useEffect(() => {
    fetch(GOOGLE_SHEET_API_URL)
      .then((res) => res.json())
      .then((data) => setBlogs(data))
      .catch((err) => console.error("Error fetching blogs:", err));
  }, []);
  
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "MedicalOrganization",
    name: "Krisara Gastro and Liver Clinic",
    url: "https://krisaragastro.com/",
    logo: "https://i.ibb.co/HDcnBZt3/Rectangle-76.png",
    image: "https://i.ibb.co/HDcnBZt3/Rectangle-76.png",
    telephone: "+91 7569541532",
    email: "gastro@krisara.com",
    address: {
      "@type": "PostalAddress",
      streetAddress:
        "3rd Floor, Fairmount Square, Pet Basheerabad, Quthbullapur, Kompally",
      addressLocality: "Hyderabad",
      addressRegion: "Telangana",
      postalCode: "500014",
      addressCountry: "IN",
    },
    sameAs: [
      "https://www.facebook.com/krisaragastro",
      "https://www.instagram.com/krisaragastro",
    ],
  };

  return (
    <>
      {/* ✅ Hero Section */}
      <section className="blog-hero-section">
        <div className="blog-hero-container">
          {/* Title */}
          <h1 className="blog-hero-title">Digestive Health & Gastro Blogs by <br/>Dr. Shruti Sagar</h1>
          {/* Breadcrumb */}
          <nav className="blog-hero-breadcrumb">
            <Link to="/" className="blog-hero-breadcrumb-link">
              <Home size={16} />
              Home
            </Link>
            <span className="blog-hero-breadcrumb-separator">•</span>
            <span className="blog-hero-breadcrumb-current">Blog</span>
          </nav>
          {/* Blog count */}
        </div>
      </section>
      {/* ✅ Blogs Section */}
      <section className="blogs-section">
        <div className="blogs-grid">
          {blogs.map((blog) => (
            <div className="blog-card" key={blog.id}>
              <div className="blog-image-wrapper">
                <img
                  src={blog.image_url}
                  alt={blog.title}
                  className="blog-image"/>
                <Link to={`/blogs/${blog.id}`} className="blog-hover-readmore">
                  Read More →
                </Link>
              </div>
              <div className="blog-content">     
                 <p className="blog-meta">{blog.date}</p>
                <h3 className="blog-heading">{blog.title}</h3>
              </div>
            </div>
          ))}
        </div>
        {/* Contact Section */}
      <section className="about-contact">
        <div className="about-contact-container">
          {/* Left Map */}
          <motion.div
            className="about-contact-map"
            initial={{ opacity: 0, x: -60 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.9 }}
            viewport={{ once: true }}>
            <iframe
              title="Krisara Gastro and Liver Clinic"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3804.533994012547!2d78.4850845751682!3d17.52974508338184!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb85bbfd0172fd%3A0x7fa24177c42a2214!2sKrisara%20Gastro%20and%20Liver%20Clinic%20(%20Dr.Shruti%20Sagar%20Gastroenterologist%20)!5e0!3m2!1sen!2sin!4v1757152691875!5m2!1sen!2sin"
              width="100%"
              height="100%"
              style={{ border: "0", borderRadius: "12px" }}
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </motion.div>
          {/* Right Info */}
          <motion.div
            className="about-contact-info"
            initial={{ opacity: 0, x: 60 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.9 }}
            viewport={{ once: true }}>
            <h2>KRISARA GASTRO AND LIVER CLINIC</h2>
            <div className="contact-item">
              <span className="icon location">📍</span>
              <p>
                <strong>We are located at</strong>
                <br />
                3rd Floor, Fairmount Square, Pet Basheerabad, Quthbullapur,
                Kompally, Hyderabad, Secunderabad, Telangana 500014
              </p>
            </div>
            <div className="contact-item">
              <span className="icon phone">📞</span>
              <p>
                <strong>Contact us</strong>
                <br />
                +91 7569-541-532
              </p>
            </div>
            <div className="contact-item">
              <span className="icon email">✉️</span>
              <p>
                <strong>Email us</strong>
                <br />
                Gastro@krisara.com
              </p>
            </div>
            <Link to="/appointment">
              <motion.button style={{backgroundColor:"black"}}
                className="contact-cta"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}>
                Book an Appointment
              </motion.button>
            </Link>
          </motion.div>
        </div>
      </section>
      </section>
    </>
  );
}